export class BaseOption {
  id: number;
  name: string;
}
